import { render, staticRenderFns } from "./OzpartsAu.vue?vue&type=template&id=51ab50a6&scoped=true&"
import script from "./OzpartsAu.vue?vue&type=script&lang=js&"
export * from "./OzpartsAu.vue?vue&type=script&lang=js&"
import style0 from "./OzpartsAu.vue?vue&type=style&index=0&id=51ab50a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab50a6",
  null
  
)

export default component.exports